module.exports = __webpack_public_path__ + "img/individual@2x.06e9e43.webp";